<template>
    <div class="row">
        <div class="col-12">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="card-header-2">
                                <h5>New Carrier Information</h5>
                            </div>
                            <v-form class="theme-form theme-form-2 mega-form" ref="form">
                                
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Name</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="Name" v-model="name" :rules="[(v) => !!v || 'Item is required']"></v-text-field>
                                        </div>
                                    </div>
                                </div>
                            
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Email</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="Email" v-model="email"></v-text-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Phone</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="Phone" v-model="phone"></v-text-field>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">URL</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="URL" v-model="URL"></v-text-field>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="d-flex flex-column">
                                    <v-btn class="mt-4" color="success" block @click="validate"> Create </v-btn>
                                </div>
                            </v-form>
                        </div>

                        <v-alert v-if="messageError != ''" :type="typeOfMessage" :text="messageError"></v-alert>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import axios from 'axios'

export default {
    name: 'app',
    title: 'New carrier',
    watch: {
        country() {

            
        },
    },
    data() {
        return {
            id: null,
            
            name: '',
            email: '',
            phone: '',
            URL: '',
            messageError: '',
            typeOfMessage: ''
        }
    },
    methods: {
        async validate() {
            const { valid } = await this.$refs.form.validate()

            if (valid) {
                this.create()
            } else {
                alert('Faltan parametros')
            }
        },
        resetValidation() {
            this.$refs.form.resetValidation()
        },
       
        create() {
            let newObject = {
           
                name: this.name,
                email: this.email,
                phone: this.phone,
                URL: this.URL,
            }


             axios.post('http://localhost:8001/admin/carrier/create', newObject, {
                responseType: 'json' // Especifica el tipo de respuesta
            }).then((response) => {
                if (response.data.error) {
                    this.messageError = response.data.message
                    this.typeOfMessage = 'error'
                } else {
                    this.messageError = response.data.message
                    this.typeOfMessage = 'success'
                }
                setTimeout(() => (this.messageError = ''), 10000)
            })
            .catch((error) => {
                this.messageError = 'Error! El registro no se ha creado.'
                this.typeOfMessage = 'error'
                setTimeout(() => (this.messageError = ''), 10000)
                
            })
        }
    },

}
</script>

<style></style>
